export const ONBOARDING_WIZARD_SET_STEP = 'ONBOARDING_WIZARD_SET_STEP'
export const ONBOARDING_WIZARD_SET_STEPS = 'ONBOARDING_WIZARD_SET_STEPS'
export const ONBOARDING_WIZARD_SET_STATUS = 'ONBOARDING_WIZARD_SET_STATUS'

export const ONBOARDING_WIZARD_SET_EXPERIMENT = 'ONBOARDING_WIZARD_SET_EXPERIMENT'

export const ONBOARDING_WIZARD_SET_INTEGRATION_FORM = 'ONBOARDING_WIZARD_SET_INTEGRATION_FORM'
